import { render, staticRenderFns } from "./PlayerResource.vue?vue&type=template&id=6e43e93c&"
import script from "./PlayerResource.vue?vue&type=script&lang=ts&"
export * from "./PlayerResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports